import { WebApiModelsMemberField } from "../Repository/eventbookyapi";
import { TextService } from "../Services/TextService";
import { MemberFieldTypes } from "../Types/MemberFieldTypes"

export const mapDynamicInputName = (field: WebApiModelsMemberField) => {
    const GetText = TextService.GetText;

    if (field.columnType === MemberFieldTypes.Custom) {
        return `${field.id}`;
    }

    switch (field.columnType!) {
        case MemberFieldTypes.UniqueId:
            return "uniqueId";
        case MemberFieldTypes.FirstName:
            return "firstName";
        case MemberFieldTypes.LastName:
            return "lastName";
        case MemberFieldTypes.Email:
            return "email"
        case MemberFieldTypes.Email2:
            return "email2"
        case MemberFieldTypes.Address:
            return "address"
        case MemberFieldTypes.PhoneNumber:
            return "phoneNumber"
        case MemberFieldTypes.PostalCode:
            return "postalCode";
        case MemberFieldTypes.PostalArea:
            return "postalArea";
        case MemberFieldTypes.Title:
            return "title";
        case MemberFieldTypes.Country:
            return "country";
        case MemberFieldTypes.Company:
            return "company";
        case MemberFieldTypes.Extra1:
            return "extra1";
        case MemberFieldTypes.Extra2:
            return "extra2";
        case MemberFieldTypes.Extra3:
            return "extra3";
        case MemberFieldTypes.EmailNotificationPreference:
            return "emailNotificationPreference";
        case MemberFieldTypes.PersonalNumber:
            return "personalNumber";
        case MemberFieldTypes.PhoneNumber2:
            return "phoneNumber2";
        case MemberFieldTypes.AdressRow2:
            return "adressRow2";
        case MemberFieldTypes.AdressRow3:
            return "adressRow3";
        case MemberFieldTypes.JoinedDate:
            return "joinedDate";
        case MemberFieldTypes.WebPage:
            return "webPage";
        case MemberFieldTypes.Membership:
            return "membership";
        default:
            return "Unknown";
    }
}